var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WsIconTitle001',{attrs:{"icon":"icon-water"}},[_vm._v(" title ")])
}
var staticRenderFns = []

export { render, staticRenderFns }